export default function (value) {
  return value.toLocaleString('ru-RU', {useGrouping: true});
}
